import { ensureTrailingSlash } from '../utils/urlHelper';
import ApiServiceBase from './apiServiceBase';
import { IFetchMatchesRequest, IFetchMatchesResponse } from './models/synonyms';
import { AxiosRequestConfig, Method } from 'axios';

export default class SynonymsApiService extends ApiServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		const baseConfig = super.createBaseRequest();
		return {
			...baseConfig,
			baseURL: ensureTrailingSlash(baseConfig.baseURL) + 'services/synonyms'
		};
	}

	public async fetchMatches(data: IFetchMatchesRequest): Promise<IFetchMatchesResponse> {
		const request = {
			url: '/FetchMatches',
			method: 'post' as Method,
			data: data,
			...this.createBaseRequest()
		};

		const response = await super.sendAsync<IFetchMatchesResponse>(request);
		this.throwIfFailedResponse(response, localize('Error while fetching matches.'));

		return response.data ?? null;
	}
}
